import Vue from 'vue'
import { BootstrapVue, IconsPlugin, BIcon, VBTooltipPlugin } from 'bootstrap-vue' //IconsPlugin
import VueMoment from 'vue-moment'
import moment from 'moment'

Vue.use(VueMoment)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VBTooltipPlugin)
Vue.component('BIcon', BIcon)

